<!--  -->
<template>
  <div>
    <div class>
      <el-steps :active="1" align-center>
        <el-step title="基本信息" @click.native="on_click('csbase')" />
        <el-step title="报名条件" @click.native="on_click('cscondition')" />
        <el-step title="价格相关" @click.native="on_click('csprice')" />
        <el-step title="报表相关" @click.native="on_click('csrpt')" />
        <el-step title="调查问卷" @click.native="on_click('csinvest')" />
        <el-step title="能力项设置" @click.native="on_click('csability')" />
      </el-steps>
    </div>
    <br/>
    <div class='divMessage'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ message }}</div>
    <br/>
    <div>
      <el-card class="aui-card--fill"
                shadow="never">
            <el-form label-position="top"
               label-width="145px"
               :model="inServForm"
               :rules="dataRule"
               ref="inServForm">
            <el-row >
              <el-col :span="6">
                <!-- 开课前-->
                <el-form-item :label="$t('couse.couseq')" prop="deadLineDays">
                  <div id="container">
                    <div class="box1">
                      <el-tooltip content="截止报名(替换)" placement="bottom" effect="light">
                     <el-input v-model.number="inServForm.deadLineDays" oninput="value=value.replace(/[^\d.]/g,'')"
                                @keyup.native="deadLineDays"
                                onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"
                                style="width: 80px; float: left;">
                        </el-input>
                      </el-tooltip>
                    </div>
                    <!-- <div style="text-align:right;"  class="inputBox">  -->
                    <div class="box2"
                        style="width: 80px; float: left;">
                      <!-- <el-col :span="13"> -->
                    <el-tooltip content="截止报名(替换)" placement="bottom" effect="light">
                      <el-select v-model="inServForm.deadLineFlag"
                           filterable
                           clearable>
                        <el-option v-for="item in cousedaylist"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                        </el-option>
                      </el-select>
                         </el-tooltip>
                      <!-- </el-col> -->
                    </div>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 启用等待名单-->
                 <el-form-item :label="$t('couse.qiy')" prop="waitingListFlag">
                <el-select v-model="inServForm.waitingListFlag"
                           filterable
                           clearable
                           :placeholder="$t('user.select')">
                  <el-option v-for="(item,index) in newcourseProjectCF"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              </el-col>
                 <el-col :span="6">
                <!-- 允许店内替换-->
                <el-form-item :label="$t('couse.yxdealer')" prop="replaceUserFlag">
                  <el-tooltip content="截止替换时间与截止报名日期一致" placement="bottom" effect="light">
                  <el-select v-model="inServForm.replaceUserFlag" >
                    <el-option v-for="item in couseyesno"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                    </el-option>
                  </el-select>
                  </el-tooltip>
                  <!-- <span>截止替换时间与截止报名日期一致</span> -->
                </el-form-item>
              </el-col>
                <el-col :span="6">
                <!-- 培训需求收集-->
                <el-form-item :label="$t('couse.pxx')" prop="collectionDemandFlag">
                  <el-select v-model="inServForm.collectionDemandFlag" >
                    <el-option v-for="item in couseyesno"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row >
                  <el-col :span="6">
                <!-- 允许重复报名-->
                <el-form-item :label="$t('couse.rxc')" prop="repeatRegistFlag">
                  <el-select v-model="inServForm.repeatRegistFlag" >
                    <el-option v-for="item in couseyesno"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 限制撤销报名-->
                <el-form-item :label="$t('couse.xz')" prop="revokeRegistFlag">
                  <el-select v-model="inServForm.revokeRegistFlag" >
                    <el-option v-for="item in couseyesno"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="inServForm.revokeRegistFlag == '10'">
                <!-- 限制撤销报名天数-->
                <el-form-item :label="$t('couse.xxc')"  prop="revokeRegistDays">
                  <el-input v-model.number="inServForm.revokeRegistDays"
                  onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))" oninput="value=value.replace(/[^\d.]/g,'')" change="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"
                            @keyup.native="revokeRegistDays" class="inputBox">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="1">
              <el-col :span="12">
                <el-form-item label="    ">
                  <div class="location-layout"
                      v-if="inServForm.repeatRegistFlag == '20'">
                    <el-checkbox v-model="inServForm.repeatRegistRegisted" label="true"
                    true-label="true" false-label="false"
                                size="medium">状态为已报名的不可重复报名</el-checkbox>
                  </div>
                  <div class="location-layout"
                      v-if="inServForm.repeatRegistFlag == '20'">
                       <!-- label="状态为已完成的不可重复报名" -->
                    <el-checkbox v-model="inServForm.repeatRegistComplete" label="true"
                    true-label="true" false-label="false"
                                >状态为已完成的不可重复报名</el-checkbox>
                  </div>
                  <div class="location-layout"
                      v-if="inServForm.repeatRegistFlag == '20'">
                      <!-- label="状态为未完成的不可重复报名" -->
                    <el-checkbox v-model="inServForm.repeatRegistIncomplete"
                    true-label="true" false-label="false"
                                label="true"
                                size="medium">状态为未完成的不可重复报名</el-checkbox>
                  </div>

                </el-form-item>
              </el-col>
            </el-row>
                 <!-- 基本信息 -->
          <div class="opten-title">
            {{$t('couse.conditiontile')}}  <span style="font-size: 10pt;" >   {{$t('couse.conditionnotice')}}</span></div>
            <el-button  type="primary"
                      @click="courseAdd(inServForm.courseConditionList)">添加新选项</el-button>
            <!-- "initcon" -->
            <el-table :data="infiledLists2"
                      :show-header="false"
                      style="width: 100%;text-align: left;"
                      :row-class-name="tableRowClassName"
                      border
                      stripe
                      empty-text=" ">
              <el-table-column label="coursecode"
                              prop="options"
                              min-width="100px"
                              width="300px"
                              align="center">
                <template slot-scope="scope">
                  <span>{{$t('couse.allname')}}</span>
                </template>
              </el-table-column>
              <el-table-column label="coursecode"
                              prop="state"
                              min-width="180px"
                              width="400px"
                              align="center">
                <template slot-scope="scope">
                  <span>{{$t('couse.allstate')}}</span>
                </template>
              </el-table-column>
              <el-table-column label="coursecode"
                              prop="optype"
                              min-width="80px"
                              align="center">
                <template slot-scope="scope">
                  <span>{{$t('couse.alltype')}}</span>
                </template>
              </el-table-column>
               <!-- fixed="right" -->
              <el-table-column align="center"
                              width="80"
                              label="Operation"
                              >
                <template slot-scope="scope">
                  <span>{{$t('couse.allcz')}}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-table
                      :data="inServForm.courseConditionList"
                      id="download"
                      :show-header="false"
                      border
                      stripe
                      empty-text=" "
                      >
              <el-table-column label=""
                              min-width="140px"
                              align="left">
                 <template slot-scope="scope">
                  <condition @appenddata="appenddata"
                            @inputs="inputs"
                            @hiddens="hiddens"
                            @dayslist="dayslist"
                            :days="scope.row.days"
                            :inputvaluestrue22="scope.row.daysdisplay"
                            :inputvalues="scope.row.courseConditionList"
                            :inputvalues22="scope.row.optionIndex"
                            :inputvaluesfu="inServForm.courseConditionList"
                            :inputindex="scope.$index"
                            ref="condition"></condition>
                </template>
              </el-table-column>
            </el-table>
            <!------------------------------------------->
            <!-- 注释掉 ---->
            <!-------------->
            <div> <span style="font-size: 10pt;" color="#FF0000">{{$t('couse.conditiondesc')}}</span> </div>
             <div class="opten-title">
                {{$t('couse.conditionlimit')}}</div>
            <template>
              <el-row :gutter="1">
                <el-col :span="6">
                  <el-form-item label="   ">
                      <el-radio label="0" v-model="inServForm.limitRegistFlag">{{ $t('couse.dealer') }}</el-radio>
                      <el-radio label="1" v-model="inServForm.limitRegistFlag">{{ $t('couse.dealerwx') }}</el-radio>
                    <!-- </el-radio-group> -->
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <!-- 限定标准-->
                  <div class="location-layout" v-if="inServForm.limitRegistFlag != '1'">
                    <el-form-item :label="$t('couse.xdstandard')">
                      <el-select v-model="inServForm.limitCourseFlag" >
                        <el-option v-for="item in cousebz"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
            <!--开始时间-->
            <el-col :span="12" v-if="inServForm.limitCourseFlag == '10' && inServForm.limitRegistFlag != '1'">

                  <el-col :span="10">
                       <el-form-item :label="$t('couse.limitCourseStartdate')" prop="limitCourseStartdate">
                    <el-date-picker width="40px" v-model="inServForm.limitCourseStartdate" :placeholder="$t('couse.startdate')" type="date" value-format="yyyy-MM-dd" />
                  </el-form-item>
                  </el-col>
                  <el-col :span="2" align="center">
                    <el-form-item >
                       <span slot="label">&nbsp;&nbsp;&nbsp;</span>
                       <span>-</span>
                    </el-form-item></el-col>
                  <el-col :span="10">
                     <el-form-item prop="limitCourseEnddate">
                       <span slot="label">&nbsp;&nbsp;&nbsp;</span>
                    <el-date-picker v-model="inServForm.limitCourseEnddate"
                                width="40px"
                                :placeholder="$t('couse.enddate')"
                                type="date"
                                value-format="yyyy-MM-dd" />
                     </el-form-item>
                  </el-col>

              </el-col>
              </el-row>
            </template>
            <el-row :gutter="25">
              <el-col>
                <el-form-item label="    ">
                  <div v-if="inServForm.limitRegistFlag==='0'||inServForm.limitRegistFlag==='6'">
                    <el-row :gutter="25">
                      <el-col :span="24">
                        <el-col :span="5">
                            <el-radio  v-model="inServForm.limitDefineFlag" label="3" >每家经销商限制最多</el-radio>
                        </el-col>
                        <el-col :span="19" v-if="inServForm.limitDefineFlag==='3'">
                           <el-form-item label="" prop="limitDealerNumber">
                           <!-- <el-col :span="8"> -->
                             <div id="container">
                               <div class="box1">
                            <el-input  style=" width: 100px;float: left;"
                            v-model.number="inServForm.limitDealerNumber"
                               @keyup.native="number"
                               change="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"
                               onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"
                               oninput="value=value.replace(/[^\d.]/g,'')">
                            </el-input>
                               </div>
                               <div class="box2" style=" width: 100px;float: left;">
                          <!-- </el-col> -->
                          <!-- <el-col :span="12"> -->
                            <span>人报名</span>
                               </div>
                            </div>
                            </el-form-item>
                          <!-- </el-col> -->
                        </el-col>
                        <!-- <el-col :span="4" v-if="inServForm.limitDefineFlag==='3'"><span>人报名</span></el-col> -->
                      </el-col>
                    </el-row>
                    <el-row :gutter="25">
                      <el-col :span="12">
                        <el-col :span="12">
                          <!-- <el-radio-group v-model="inServForm.limitDefineFlag"> -->
                            <el-radio v-model="inServForm.limitDefineFlag" label="1" >自定义上传</el-radio>
                          <!-- </el-radio-group> -->
                        </el-col>
                        <el-col :span="12">
                          <el-button size="small"  @click="upload" :disabled = "inServForm.limitDefineFlag !== '1'"
                                      type="primary">点击上传</el-button>
                        </el-col>
                      </el-col>
                      <el-col :span="10">
                        <el-col :span="10">
                        </el-col>
                        <el-col :span="10">
                          <div style="float:left;width:300px; height:100%; ">
                            <span>除上传经销商外，其他经销商不受限制</span>
                          </div>
                        </el-col>
                      </el-col>
                      <el-col :span="10">
                      </el-col>
                    </el-row>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row >
              <el-col :span="6">
                <!-- 是否限制学习-->
                <el-form-item :label="$t('couse.ynstudy')" prop="limitVisiableFlag">
                  <el-select v-model="inServForm.limitVisiableFlag" >
                    <el-option v-for="item in couseyesno"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <!-- 站内信推送-->
                <el-form-item :label="$t('couse.zpush')" prop="sendNoticeFlag" >
                  <el-select v-model="inServForm.sendNoticeFlag" >
                    <el-option v-for="item in couseyesno"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
               <el-col :span="6">
                <!-- 允许兼职职位报名-->
                <el-form-item :label="$t('couse.allowjob')" prop="limitPartTimeJob">
                  <el-select v-model="inServForm.limitPartTimeJob" >
                    <el-option v-for="item in couseyesno"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="1">
              <el-col :span="24">
                <!-- <el-form-item label=""> -->
                  <!--面向群组 -->
                   <el-button
                        type="primary"
                        @click.native.prevent="dialogTableVisible = true">{{ $t('couse.mgroup') }}</el-button>
                  <el-dialog title="面向群组查询"
                       :modal="false"
                       :visible.sync="dialogTableVisible"
                       @close="closeFun">
                    <div style="height: 600px;">
                    <!-- <courseds @inputss="inputss">
                    </courseds> -->
                    <coursedcreat @courescreat=courescreat>
                    </coursedcreat>
                    </div>
                  </el-dialog>
                   <!--创建群组 -->
                   <span>&nbsp;&nbsp;</span>
                   <el-button
                        type="primary"
                        @click.native="gotoView(1)">{{ $t('couse.creatmgroup') }}</el-button>

              </el-col>
            </el-row>
            <el-row :gutter="25">
              <el-form-item label="">
                <template>
                  <el-table :data="inServForm.courseGroupList"
                            :show-header="false"
                            >
                    <el-table-column prop="groupName"
                                    label=""
                                    style="width: 80%">
                    </el-table-column>
                    <el-table-column prop="groupRemark"
                                    label=""
                                    style="width: 80%">
                    </el-table-column>
                    <el-table-column label=""
                                    width="100">
                      <template slot-scope="scope">
                        <el-button @click.native.prevent="deleteRow(scope.$index, inServForm.courseGroupList)"
                                  size="small"> 删除 </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-form-item>
            </el-row>
          </el-form>
       </el-card>
    </div>
    <!--v-if="importExcelVisible" inServForm.courseId courseId="1"-->
    <courseimport v-if="importExcelVisible"
                  :courseId="inServForm.courseId"
                  url="/learning/courseinfo/import"
                  shuttering="/learning/courseinfo/import_mould"
                  :name="$t('couse.couseImporttemplate')"
                  ref="courseimport"></courseimport>
    <div>
      <el-row>
        <el-col :span="16">
          <div class="grid-content" />
        </el-col>
      </el-row>
       <el-row>
          <el-col :span="16"><div class="grid-content" /></el-col>
          <el-button @click="dataFormSubmitHandle"  type="primary">保存并下一步</el-button>
          <el-button @click="dataFormSubmitHandle2"  type="primary">保存</el-button>
          <el-button >取消</el-button>
       </el-row>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

import coursedcreat from '../../common/coursedcreat'
// import course from '../../common/course'
import debounce from 'lodash/debounce'
import condition from './offeringConditions'
import Courseimport from './offeringimports'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    coursedcreat,
    // course,
    condition,
    // ImportExcel,
    // couseImportExcel,
    Courseimport
  },
  props: ['message', 'courseid'],
  data () {
    // 这里存放数据
    let _this = this
    return {
      mixinViewModuleOptions: {
      },
      // message: '323232',
      dialogTableVisible: false,
      courseId: '',
      importExcelVisible1: false,
      importExcelVisible: false,
      s1: '2',
      value: '',
      activ: 0,
      cousedaylist: [{
        value: 'd',
        label: '天'
      }, {
        value: 'h',
        label: '小时'
      }],
      // 是否 courseProjectCF
      newcourseProjectCF: _this.enums['courseProjectCF'],
      couseyesno: [{
        value: '10',
        label: '是'
      }, {
        value: '20',
        label: '否'
      }],
      // 限定标准
      cousebz: [{
        value: '10',
        label: '按课程'
      }, {
        value: '20',
        label: '按排期'
      }],
      // this.enums['status'],//是否为天或小时
      initcon: [],
      courseConditionList: [],
      infiledLists2: [{ options: 1 }],
      inServForm: {
        offeringId: '1',
        deadLineFlag: 'd',
        // repeatRegistRegisted: true,
        // courseId: '1',
        courseConditionList: [],
        courseLimidealerList: [],
        courseGroupList: [],
        menuId: '',
        addressbaidu: 0,
        radio: '',
        chekex1: '',
        chekex2: '',
        active: 0,
        id: 45,
        sort: 0,
        courejoblist: [],
        // courseGroupList: []
        deadLineDays: '2',
        repeatRegistFlag: '20',
        waitingListFlag: '20',
        collectionDemandFlag: '20',
        limitVisiableFlag: '10',
        sendNoticeFlag: '10',
        limitPartTimeJob: '20',
        replaceUserFlag: '10',
        revokeRegistFlag: '20',
        limitRegistFlag: '1',
        limitCourseFlag: '20',
        limitDefineFlag: '3'
      },
      dataRulez: {
        waitingListFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        coursePrice: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  // 监听属性 类似于data概念 deadLineDays
  computed: {
    dataRule () {
      // this.$message('***********************')
      //  允许店内替换  replaceUserFlag
      //  培训需求收集  collectionDemandFlag
      //  限制撤销报名  revokeRegistFlag
      //  限制撤销报名天数  revokeRegistDays
      //  允许重复报名   repeatRegistFlag
      //  是否限制学习: limitVisiableFlag
      //  站内信推送  sendNoticeFlag
      //  等候名单  waitingListFlag
      let limitCourseStartdate = (rule, value, callback) => {
        if (this.inServForm.limitCourseEnddate !== null || this.inServForm.limitCourseEnddate !== ' ') {
          if (value === this.inServForm.limitCourseEnddate && value === 0) {
            callback()
          }
          if (value >= this.inServForm.limitCourseEnddate) {
            callback(new Error('开始日期不能大于结束日期'))
          }
        }
        callback()
      }
      let limitCourseEnddate = (rule, value, callback) => {
        if (this.inServForm.limitCourseEnddate === undefined || this.inServForm.limitCourseEnddate === null || this.inServForm.limitCourseEnddate === '') {
          callback(new Error(this.$t('validate.required')))
        }
        if (this.inServForm.limitCourseStartdate !== null || this.inServForm.limitCourseStartdate !== ' ') {
          if (value === this.inServForm.limitCourseStartdate && value === 0) {
            callback()
          }
          if (value <= this.inServForm.limitCourseStartdate) {
            callback(new Error('结束日期不能小于开始日期'))
          }
        }
        callback()
      }
      return {
        courseConditionStatus: [{ type: 'string', required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        replaceUserFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        collectionDemandFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        revokeRegistFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        revokeRegistDays: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        repeatRegistFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        limitVisiableFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        sendNoticeFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        limitPartTimeJob: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        waitingListFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deadLineDays: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        limitDealerNumber: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        limitCourseStartdate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: limitCourseStartdate, trigger: 'blur' }
        ],
        limitCourseEnddate: [
          { validator: limitCourseEnddate, trigger: 'blur' }
        ]
      }
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.init()
    this.$eventHub.$on('showCourse', (data) => {
      this.init()
    })
    this.$eventHub.$on('addCourse', (data) => {
      this.again()
      this.courseId = ''
    })
    this.inServForm = {
      deadLineFlag: 'd',
      // repeatRegistRegisted: true,
      // courseId: '1',
      courseConditionList: [],
      courseLimidealerList: [],
      courseGroupList: [],
      menuId: '',
      addressbaidu: 0,
      radio: '',
      chekex1: '',
      chekex2: '',
      active: 0,
      id: 45,
      sort: 0,
      courejoblist: [],
      deadLineDays: '2',
      repeatRegistFlag: '20',
      waitingListFlag: '20',
      collectionDemandFlag: '20',
      limitVisiableFlag: '10',
      sendNoticeFlag: '10',
      limitPartTimeJob: '20',
      replaceUserFlag: '10',
      revokeRegistFlag: '20',
      limitRegistFlag: '1',
      limitCourseFlag: '20',
      limitDefineFlag: '3'
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    // this.init()
  },
  beforeCreate () {
    console.log('beforeCreate')
  }, // 生命周期 - 创建之前
  beforeMount () {
    console.log('beforeMount')
  }, // 生命周期 - 挂载之前
  beforeUpdate () {
    console.log('beforeUpdate')
  }, // 生命周期 - 更新之前
  updated () {
    console.log('updated')
  }, // 生命周期 - 更新之后
  beforeDestroy () {
    console.log('beforeDestroy')
  }, // 生命周期 - 销毁之前
  destroyed () {
    console.log('destroyed')
  }, // 生命周期 - 销毁完成
  activated () {
    this.$nextTick(() => {
      //  this.getInfo()
    })
  },
  // 方法集合
  methods: {
    // 人报名
    number () {
      var limitDealerNumber = this.inServForm.limitDealerNumber
      var sskey = limitDealerNumber.replace(new RegExp('.', 'g'), '')
      this.inServForm.limitDealerNumber = sskey
    },
    // 天数
    deadLineDays () {
      var deadLineDays = this.inServForm.deadLineDays
      var sskey = deadLineDays.replace(new RegExp('.', 'g'), '')
      this.inServForm.deadLineDays = sskey
    },
    // 格式化不能输入
    revokeRegistDays () {
      var revokeRegistDays = this.inServForm.revokeRegistDays
      var sskey = revokeRegistDays.replace(new RegExp('.', 'g'), '')
      this.inServForm.revokeRegistDays = sskey
    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex === 0) {
        return 'warning-row'
      }
      return ''
    },
    upload () {
      this.importExcelVisible = true
      this.$nextTick(() => {
        this.$refs.courseimport.init()
      })
      // this.getDataList()
    },
    sendMsg () {
      console.log('csconditionsend')
      console.log(this.courseid)
      this.$emit('onShowModer', 'cspricesend')
    },
    sendSave () {
      this.$emit('onShowModer', 'cspriceSave')
    },
    on_click (e) {
      this.$emit('onShowModer', e)
    },
    // 设置为了空白
    again () {
      this.inServForm = {
        deadLineFlag: 'd',
        // repeatRegistRegisted: true,
        // courseId: '1',
        courseConditionList: [],
        courseLimidealerList: [],
        courseGroupList: [],
        menuId: '',
        addressbaidu: 0,
        radio: '',
        chekex1: '',
        chekex2: '',
        active: 0,
        id: 45,
        sort: 0,
        courejoblist: [],
        // courseGroupList: []
        deadLineDays: '2',
        repeatRegistFlag: '20',
        waitingListFlag: '20',
        collectionDemandFlag: '20',
        limitVisiableFlag: '10',
        sendNoticeFlag: '10',
        limitPartTimeJob: '20',
        replaceUserFlag: '10',
        revokeRegistFlag: '20',
        limitRegistFlag: '1',
        limitCourseFlag: '20',
        limitDefineFlag: '3'
      }
    },
    // 页面初始化
    init () {
      this.again()

      if (this.$route.query.courseId !== undefined) {
        this.inServForm.courseId = this.$route.query.courseId
        this.getDealerBeforeGetInfo()
      }
    },
    getDealerBeforeGetInfo () {
      // this.$request.post(`/learning/course/courseinfo/courseConditionUpdate`,
      this.$request.get('/learning/base/offeringinfo/offeringConditionList',
        { courseId: this.inServForm.courseId }
      ).then((res, total, code, data) => {
        this.inServForm = data.data
      }).catch((err) => {
        console.log(err)
      })
    },
    gotoView (id) {
      this.$router.push({
        name: 'learning-coursectg-cataglog'
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      // 有输入天数的要必填
      var dayss = true
      var courseConditionList = true
      var courseConditionListzilist = true
      var courseUplodlist = true
      this.inServForm.courseConditionList.forEach(row => {
        if (row.courseConditionList.length === 0) {
          courseConditionListzilist = false
        }
        if (row.daysdisplay !== '20') {
          row.days = null
        }
        if (row.daysdisplay === '20' && row.days === undefined) {
          dayss = false
        }
        if (row.daysdisplay === '20' && (row.days === undefined || row.days === '' || row.days === null)) {
          dayss = false
        }
        row.courseConditionList.forEach(row2 => {
          if (row2.courseConditionStatus.length === 0) {
            courseConditionList = false
          }
          // 设置为空
          if (row.daysdisplay !== '20') {
            row2.days = null
          }
        })
      })
      if (this.inServForm.limitDefineFlag === '1') {
        this.getDealeruplodlistInfo()
        courseUplodlist = this.courseUplodlist
      }

      if (this.inServForm.limitCourseStartdate === null || this.inServForm.limitCourseStartdate === '') {
        this.inServForm.limitCourseStartdate = null
      }
      if (this.inServForm.limitCourseStartdate != null && this.inServForm.limitCourseStartdate !== '') {
        this.inServForm.limitCourseStartdate = this.inServForm.limitCourseStartdate + ''
      }

      if (this.inServForm.limitCourseEnddate === null || this.inServForm.limitCourseEnddate === '') {
        this.inServForm.limitCourseEnddate = null
      }
      if (this.inServForm.limitCourseEnddate != null && this.inServForm.limitCourseEnddate !== '') {
        this.inServForm.limitCourseEnddate = this.inServForm.limitCourseEnddate + ''
      }
      this.inServForm.courseId = this.courseid
      let dataFormModify = JSON.parse(JSON.stringify(this.inServForm))
      this.$refs['inServForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        if (!courseConditionListzilist) {
          this.$message({
            showClose: true,
            message: '选项下没有子项',
            type: 'error',
            duration: 5000
          })
          return false
        }
        if (!courseConditionList) {
          this.$message({
            showClose: true,
            message: '状态不允许为空',
            type: 'error',
            duration: 5000
          })
          return false
        }
        if (!dayss) {
          this.$message({
            showClose: true,
            message: '天数不允许为空',
            type: 'error',
            duration: 5000
          })
          return false
        }
        if (!courseUplodlist) {
          this.$message({
            showClose: true,
            message: '自定义上传没有上传文件',
            type: 'error',
            duration: 5000
          })
          return false
        }
        this.$request.post(`/learning/base/offeringinfo/courseConditionUpdate`,
          dataFormModify
        ).then((res, total, code, data) => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500

          })
          this.sendMsg()
        }).catch((err) => {
          console.log(err)
        })
      })
    }, 1000, { 'leading': true, 'trailing': false }),
    // 表单提交
    dataFormSubmitHandle2: debounce(function () {
      this.inServForm.offeringId = '1'
      var dayss = true
      var courseConditionList = true
      var courseConditionListzilist = true
      var courseUplodlist = true
      this.inServForm.courseConditionList.forEach(row => {
        if (row.courseConditionList.length === 0) {
          courseConditionListzilist = false
        }
        if (row.daysdisplay !== '20') {
          row.days = null
        }
        if (row.daysdisplay === '20' && row.days === undefined) {
          dayss = false
        }
        if (row.daysdisplay === '20' && (row.days === undefined || row.days === '' || row.days === null)) {
          dayss = false
        }
        row.courseConditionList.forEach(row2 => {
          if (row2.courseConditionStatus.length === 0) {
            courseConditionList = false
          }
          // 设置为空
          if (row.daysdisplay !== '20') {
            row2.days = null
          }
        })
      })
      if (this.inServForm.limitDefineFlag === '1') {
        this.getDealeruplodlistInfo()
        courseUplodlist = this.courseUplodlist
      }
      this.inServForm.courseId = this.courseid
      if (this.inServForm.limitCourseStartdate === null || this.inServForm.limitCourseStartdate === '') {
        this.inServForm.limitCourseStartdate = null
      }

      if (this.inServForm.limitCourseEnddate === null || this.inServForm.limitCourseEnddate === '') {
        this.inServForm.limitCourseEnddate = null
      }
      let dataFormModify = JSON.parse(JSON.stringify(this.inServForm))
      this.$refs['inServForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        if (!courseConditionListzilist) {
          this.$message({
            showClose: true,
            message: '选项下没有子项',
            type: 'error',
            duration: 5000
          })
          return false
        }
        if (!courseConditionList) {
          this.$message({
            showClose: true,
            message: '状态不允许为空',
            type: 'error',
            duration: 5000
          })
          return false
        }
        if (!dayss) {
          this.$message({
            showClose: true,
            message: '天数不允许为空',
            type: 'error',
            duration: 5000
          })
          return false
        }
        if (!courseUplodlist) {
          this.$message({
            showClose: true,
            message: '自定义上传没有上传文件',
            type: 'error',
            duration: 5000
          })
          return false
        }
        //  dataFormModify.motherShopId = this.select2
        this.$request.post(`/learning/base/offeringinfo/courseConditionUpdate`,
          dataFormModify
        ).then((res, total, code, msg, data) => {
          if (code === 2) {
            this.$message({
              showClose: true,
              message: msg.msg,
              type: 'error',
              duration: 500
            })
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500
          })
          this.sendSave()
        }).catch((err) => {
          console.log(err)
        })
      })
    }, 1000, { 'leading': true, 'trailing': false }),
    // 查询是否上传
    getDealeruplodlistInfo () {
      this.inServForm.courseId = this.courseid
      this.$request.get('/learning/base/offeringinfo/uplodlist',
        { courseId: this.inServForm.courseId }
      ).then((res, total, code, data) => {
        this.inServForm.courseLimidealerList = data.data
        // 为大于0的说明上传成功
        if (data.data.length > 0) {
          this.courseUplodlist = true
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    backPage () {
      this.$router.go(-1)
    },
    courescreat: function (data) {
      // this.$message(data)
      this.inServForm.courseGroupList = data
    },
    courseAdd (tableData, event) {
      if (this.inServForm.addressbaidu === undefined) {
        this.inServForm.addressbaidu = 0
      }
      // 清空时 从0开始
      let courseConditionList = this.inServForm.courseConditionList
      var max = 0
      if (courseConditionList.length === 0) {
        this.inServForm.addressbaidu = 0
      } else {
        courseConditionList.forEach(row => {
          var number = parseInt(row.optionIndex, 10)
          if (max <= number) {
            max = number
          }
        })
      }
      var count = Number(max) + Number(1)
      tableData.push({ optionIndex: '' + count, daysdisplay: '10', statu: '', courseConditionList: [] })
      // tableData.push({tableData:{ye:'0', fildna: '选项'+count,status:''}})
    },
    reds: function (index) {
      this.changeRed = index
    },
    getCheckedNodes () {
      var ridsb = this.$refs.tree.getCheckedNodes()// 获取当前的选中的数据{对象}
      ridsb.forEach(ids => {
        this.inServForm.tableData.push({ jobname: ids.label, jobcode: ids.id })
      })
    },
    clickitem (e) {
      //e === this.inServForm.limitRegistFlag ? this.inServForm.limitRegistFlag = e : this.inServForm.limitRegistFlag = e
      this.inServForm.limitRegistFlag = e
      if (this.inServForm.limitRegistFlag === 0) {
        this.inServForm.limitDefineFlag = '3'
        this.inServForm.radiogeo = ''
      } else if (this.inServForm.limitRegistFlag === 3) {
        this.inServForm.radiogeo = 3
      } else {
        this.inServForm.radiogeo = ''
      }
    },
    // 设置 列表文本框是否隐藏
    hiddens: function (list) {
      this.inServForm.courseConditionList.forEach(row => {
        if (row.optionIndex === list[0].names) {
          // 隐藏值
          row.daysdisplay = list[0].hiddernames
        }
      })
    },
    // dayslist 获取天数
    dayslist: function (list) {
      this.inServForm.courseConditionList.forEach(row => {
        if (row.optionIndex === list[0].names) {
          // 隐藏值
          row.days = list[0].days
        }
      })
    },
    // 默认30 已完成
    appenddata: function (list) {
      this.inServForm.courseConditionList.forEach(row => {
        if (row.optionIndex === list[0].names) {
          list[0].data.forEach(rows => {
            // this.unique({ conditionCourseId: rows.id, course: rows.course, courseKind: rows.courseKind, courseConditionStatus: ['30'] })
            row.courseConditionList.push({ conditionCourseId: rows.id, course: rows.course, courseKind: rows.courseKind, courseConditionStatus: ['30'] })
          })
        }
      })
      this.inServForm.courseConditionList.forEach(row => {
        row.courseConditionList = this.quchong(row.courseConditionList)
      })
      // this.inServForm.courseConditionList = this.unique(this.inServForm.courseConditionList)
    },
    quchong (arr) {
      var result = []
      var obj = {}
      for (var i = 0; i < arr.length; i++) {
        if (!obj[arr[i].course]) {
          result.push(arr[i])
          obj[arr[i].course] = true
        }
      }
      return result
    },
    // 去重
    unique (arr) {
      if (!Array.isArray(arr)) {
        console.log('Type Error!')
        return false
      }
      var array = []
      for (var i = 0; i < arr.length; i++) {
        if (array.indexOf(arr[i]) !== -1) {
          array.push(arr[i])
        }
      }
      return array
    },
    // 集合去重
    uniqArrObject (arr) {
      let result = {}
      let finalResult = []
      for (let i = 0; i < arr.length; i++) {
        result[arr[i].course] = arr[i]
      }
      for (let key in result) {
        finalResult.push(result[key])
      }
      return finalResult
    },

    closeFun () { // 关闭时清空选中的
      this.$refs.multipleTable.clearSelection()// 清空
    },
    inputs: function (data) {
      // var indexx = 0
      var str = ''
      data.forEach(row => {
        str = row.name
        // indexx = row.indexs
        // indexx = ++index
      })
      var strs // =new Array()
      strs = str.split(',')
      for (var i = 0; i < strs.length; i++) {
        // document.write(strs[i]+"<br/>"); //分割后的字符输出
      }
    },

    deleteRow (index, rows) { // 删除改行
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('couse.undercarriage') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel')
      }).then(() => {
        rows.splice(index, 1)
      }).catch((err) => {
        console.log(err)
      })
    },
    objectArraySort (keyName) {
      return function (objectN, objectM) {
        var valueN = objectN[keyName]
        var valueM = objectM[keyName]
        if (valueN < valueM) return 1
        else if (valueN > valueM) return -1
        else return 0
      }
    },
    // 定义在每个小节的内部进行转化的方法，其他部分则与小节内部转化方法相同
    // 获取表格选中时的数据
    selectRow (val) {
      this.selectlistRow = val
    },

    // 增加行
    addRow () {
      var list = {
        rowNum: '',
        address: this.address,
        name: this.name,
        weather: this.weather,
        phone: this.phone,
        date: this.date,
        mdate: this.mdate,
        loveer: this.loveer
      }
      this.tableData.unshift(list)
    },
    // 删除方法
    // 删除选中行
    delData () {
      this.$confirm('111', '333', {
        confirmButtonText: '444',
        cancelButtonText: '111'
      }).then(() => {
        for (let i = 0; i < this.selectlistRow.length; i++) {
          let val = this.selectlistRow
          // 获取选中行的索引的方法
          // 遍历表格中tableData数据和选中的val数据，比较它们的rowNum,相等则输出选中行的索引
          // rowNum的作用主要是为了让每一行有一个唯一的数据，方便比较，可以根据个人的开发需求从后台传入特定的数据
          val.forEach((val, index) => {
            this.tableData.forEach((v, i) => {
              if (val.rowNum === v.rowNum) {
                // i 为选中的索引
                this.tableData.splice(i, 1)
              }
            })
          })
        }
        // 删除完数据之后清除勾选框
        this.$refs.tableData.clearSelection()
      }).catch((err) => {
        console.log(err)
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.el-form-item__error {
    color: #F56C6C;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
}
.el-table .warning-row {
     /* background: gray; */
     background: #ebecf0;
}
</style>

<style lang='scss' scoped>

.el-form-item.is-required>.el-form-item__label:before {
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
}
.grid-content {
    border-radius: 4px;
    min-height: 36px;
  }

  .c-11 {
  border-radius: 50%;
  border: 15px solid;
  border-color: inherit;
}
// .el-table .warning-row {
//   /*//background: oldlace;*/
//   background: oldlace;
// }

// .el-table .success-row {
//   background: #fbf4ff;
// }
// * {
//   padding: 0;
//   margin: 0;
// }
.box {
  height: 40px;
  background: cyan;
}
.nav {
  line-height: 40px;
  display: inline-block;
  margin-left: 100px;
  cursor: pointer;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
#container {
  overflow: hidden;
} /* 清除浮动 */

/* #container div{height:100px;} */
#container div {
  /* width: 100px; */
  display: inline-block;
}

.box1 {
  /* background: red; */
  float: left;
}
.box12 {
  float: right;
}
.box2 {
  /* background: green; */
  float: left;
}
.box3 {
  float: left;
}

.el-table >>> td {
  padding: 1px;
  padding-left: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
}
.el-table >>> th {
  padding: 1px;
  padding-left: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
}

</style>
